import React from "react";

const SectionContent = ({ children }) => {
  return (
    <div className="flex flex-col gap-4 w-full bg-white shadow-lg border rounded-lg p-5">
      {children}
    </div>
  );
};

export default SectionContent;
